import { Box, Flex, HStack, Text } from '@chakra-ui/react';
import { IconClock } from 'central-icons/IconClock';
import { IconMapPin } from 'central-icons/IconMapPin';
import { format as d3Format } from 'd3-format';

interface ProfileHeaderProps {
  currentTitle: string;
  yearsOfExperience?: number;
  location?: string;
}

export const ProfileHeader = ({
  currentTitle,
  yearsOfExperience,
  location,
}: ProfileHeaderProps) => {
  return (
    <Flex
      fontSize="sm"
      color="text.primary"
      columnGap={4}
      rowGap={2}
      align="start"
      flexWrap="wrap"
    >
      <Text>{currentTitle}</Text>
      {!!yearsOfExperience && (
        <HStack spacing={1} align="center">
          <Box flexShrink={0}>
            <IconClock size={16} />
          </Box>
          <Text>
            {String(d3Format('.1~f')(Number(yearsOfExperience))) + ' Years'}
          </Text>
        </HStack>
      )}
      {location && (
        <HStack spacing={1} align="center">
          <Box flexShrink={0}>
            <IconMapPin size={16} />
          </Box>
          <Text>{location}</Text>
        </HStack>
      )}
    </Flex>
  );
};
